import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../../../utils";

export interface AddressInputStyleProps {
  margin?: string;
  hasError?: boolean;
  hasClearButton?: boolean;
  disabled?: boolean;
}

export const AddressInputWrap = styled.div<AddressInputStyleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: ${(props) => props.margin || "0"};
  width: 100%;
`;

export const AddressInputLabel = styled.label`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.greyText};
  display: block;
  margin-bottom: 8px;
  transition: all 0.3s ease;
`;

export const AddressInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const AddressInputStyle = styled.input<AddressInputStyleProps>`
  background: ${(props) =>
    props.disabled ? theme.smokeWhite : theme.whiteText};
  border: 1px solid
    ${(props) => {
      if (props.hasError) return theme.redText2;
      return theme.lightGreyText;
    }};
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  flex: 1;
  height: 44px;
  color: ${theme.blackText};
  transition: all 0.2s ease;

  &::placeholder {
    font-weight: 400;
    color: ${theme.lightBlack};
  }

  &:focus {
    outline: none;
    border: 1px solid ${theme.blueText};
    background: ${theme.whiteText};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: ${theme.smokeWhite};
    border-color: ${theme.lightGreyText};
  }

  @media ${deviceType.mobile} {
    width: 100%;
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.5;
  }

  &:focus {
    outline: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
